import { Pipe, PipeTransform} from '@angular/core';
import _ from 'lodash';

@Pipe({name: 'orderBy'})
export class OrderPipe implements PipeTransform {

	transform(list: any[], filterByField: string, order: string): any {
		if (order !== 'desc') order = 'asc';
		return _.orderBy(list, [filterByField], [order]);
	}		

}


// WEBPACK FOOTER //
// ./src/app/pipes/order-pipe.ts